import React from "react";
import { Alert, Typography } from "antd";

import { Modal } from "@components/Page";
import { W0, W1 } from "@components/Constants";

const LABEL_TITLE = "Personal Access Token Created";
const LABEL_WARNING = "Copy this token now";
const LABEL_WARNING_DESCRIPTION = "The secret is shown once and is not stored. Once this dialog is closed it cannot be retrieved again.";

type Props = {
  name?: string;
  secretToken?: string;
  isOpen: boolean;
  onClose: () => void;
};

const PersonalAccessTokenSecretModal = ({
  name,
  secretToken,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const modalProps = {
    title: LABEL_TITLE,
    isOpen,
    onClose,
  };

  return (
    <Modal {...modalProps}>
      <Alert
        showIcon
        type="warning"
        message={LABEL_WARNING}
        description={LABEL_WARNING_DESCRIPTION}
        style={{ marginBottom: W1 }}
      />

      <Typography.Paragraph strong style={{ marginBottom: W0 }}>
        {name}
      </Typography.Paragraph>

      <Typography.Paragraph
        code
        copyable={{ text: secretToken }}
        style={{ wordBreak: "break-all" }}
      >
        {secretToken}
      </Typography.Paragraph>
    </Modal>
  );
};

export default PersonalAccessTokenSecretModal;
